module.exports = __webpack_public_path__ + "img/logo_tribunnews.aeec9bd6.png";